import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Unstable_Grid2 as Grid, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { RemoveIcon, ValidatedTextFieldNext } from 'components';
import { AssignmentFragment, AssignmentInput } from 'api';

import DefineUsers from './DefineUsers';
import GroupsRequired from '../Pickers/GroupsRequired';
import GroupsSuggested from '../Pickers/GroupsSuggested';

interface Props {
  assignment?: AssignmentFragment;
}

const AssignmentForm: FC<Props> = ({ assignment }) => {
  const { t } = useTranslation();

  const { values, setFieldValue } = useFormikContext<AssignmentInput>();
  const { groups_required_ids, groups_suggested_ids } = values;

  return (
    <Fragment>
      <ValidatedTextFieldNext
        name="title"
        placeholder={t('admin:assignmentTitle')}
        InputLabelProps={{ shrink: true }}
        InputProps={{ sx: { fontSize: 32, fontWeight: 600 } }}
        fullWidth
      />

      <DefineUsers />

      <Typography
        variant="h5"
        color="textSecondary"
        sx={{ margin: theme => theme.spacing(4, 0, 0) }}
      >
        {t('admin:defineAssignments')}
      </Typography>
      <Divider sx={{ margin: theme => theme.spacing(2, -5, 2, 0) }} />

      <Grid container pl={2} pt={3} marginBottom={1}>
        <Grid xs={2}>
          <Typography variant="subtitle2">{t('common:group_plural')}</Typography>
        </Grid>
        <Grid xs={10}>
          <Typography variant="subtitle2">{t('common:required')}</Typography>
          <Typography color="textSecondary">{t('admin:onboardingGroupsRequired')}</Typography>
        </Grid>
      </Grid>

      <Grid container alignItems="center" paddingLeft={2} marginBottom={2}>
        <Grid xs={2} />
        <Grid xs={9}>
          <GroupsRequired groups={assignment?.groups_required_objects} />
        </Grid>
        {!!groups_required_ids?.length && (
          <Grid xs={1} container justifyContent="center">
            <RemoveIcon onClick={() => setFieldValue('groups_required_ids', [])} />
          </Grid>
        )}
      </Grid>

      <Grid container paddingLeft={2} marginBottom={1}>
        <Grid xs={2} />
        <Grid xs={10}>
          <Typography variant="subtitle2">{t('common:suggested')}</Typography>
        </Grid>
      </Grid>

      <Grid container alignItems="center" paddingLeft={2} marginBottom={5}>
        <Grid xs={2} />
        <Grid xs={9}>
          <GroupsSuggested groups={assignment?.groups_suggested_objects} />
        </Grid>
        {!!groups_suggested_ids?.length && (
          <Grid xs={1} container justifyContent="center">
            <RemoveIcon onClick={() => setFieldValue('groups_suggested_ids', [])} />
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default AssignmentForm;
